module.exports = __webpack_public_path__ + "img/dixie-hvac.264e707d.jpg";